function moveHeaderModules() {
  console.log("Moving header modules from Header to Menu");
  // Move animated text elements from Header into Menu
  const targetDiv = document.querySelector(".mobile-nav--main");

  document
    .querySelectorAll(
      ".shopify-section-group-header-group .animated_text_wrapper, .shopify-section-group-header-group.product-section--info-columns"
    )
    .forEach(function (e) {
      // console.log(e);

      // Copy Source Div
      const sourceDiv = e;
      const copy = sourceDiv.cloneNode(true);

      // Add to li element and append
      const li = document.createElement("li");
      li.classList.add("mobile-nav__item", "no-border");
      li.appendChild(copy);
      targetDiv.appendChild(li);

      // Remove source div
      sourceDiv.remove();
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", moveHeaderModules);
} else {
  moveHeaderModules();
}

function addCanYouRideItFonts() {
  // Find the host element
  const shadowHost = document.querySelector(
    ".toki-shopify-integration-block-form-module-root"
  );

  // Ensure the shadow root is attached
  if (shadowHost && shadowHost.shadowRoot) {
    const shadowRoot = shadowHost.shadowRoot;

    // Clone all font-related link elements from the document head
    document.querySelectorAll('link[type="font/woff2"]').forEach((link) => {
      console.log(link.href);
      const clonedLink = link.cloneNode(true);
      shadowRoot.appendChild(clonedLink);
    });

    // Create a style element
    const style = document.createElement("style");
    style.textContent = `
      :root {
        --header-font-stack: "Cooper BT", serif;
        --body-font-stack: 'NeueHelveticaPro45Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
      }
      .toki-css-reset * {
        font-family: var(--body-font-stack) !important;
      }
      .toki-title,
      label.mantine-InputWrapper-label span,
      .mantine-Checkbox-label div,
      .mantine-Button-label {
        font-family: var(--header-font-stack) !important;
      }
      .mantine-1yhvd2 {
        max-width: 800px !important;
      }
    `;

    // Append the style to the shadow root
    shadowRoot.appendChild(style);

    return true;
  } else {
    return false;
  }
}

function canYouRideIt() {
  if (document.body.id === "can-you-ride-it") {
    const addTokiInterval = setInterval(function () {
      if (addCanYouRideItFonts()) {
        clearInterval(addTokiInterval); // Stop the interval when the function returns true
      }
    }, 500);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", canYouRideIt);
} else {
  canYouRideIt();
}

// Make toki button 15% smaller on mobile
function addTokiCSS() {
  const element = document.getElementById(
    "toki-shopify-integration-embed-wallet-v2-root"
  );
  const shadowRoot = element.shadowRoot;

  if (!shadowRoot) {
    return;
  }

  // Create a style element
  const style = document.createElement("style");

  // Add the media query rule as text content
  style.textContent = `
    @media (max-width: 769px) {
      .shadow-switcher {
        height: 68px;
        width: 68px;
      }
    }
  `;

  // Append the style element to the shadow root
  shadowRoot.appendChild(style);
  element.style.display = "block";
  // console.log("Toki Wallet: Styles Injected");
  return true;
}

window.addEventListener("tokiWalletRpcInjected", function () {
  const addTokiInterval = setInterval(function () {
    if (addTokiCSS()) {
      clearInterval(addTokiInterval); // Stop the interval when the function returns true
    }
  }, 500);
});

if (typeof window.smartrrProductList === "undefined") {
  window.smartrrProductList = {};
}

function openAddToCart(id) {
  const e = document.getElementById(id);
  e.classList.add("clicked");
}

function closeAddToCart(id) {
  const e = document.getElementById(id);
  e.classList.remove("clicked");
}

function openToki() {
  const element = document.getElementById(
    "toki-shopify-integration-embed-wallet-v2-root"
  );
  const shadowRoot = element.shadowRoot;
  const button = shadowRoot.querySelector(".shadow-switcher");
  button.click();
}

function updatePriceAddToCart(id, price) {
  const e = document.getElementById(id);

  if (e) {
    e.innerText = price;
  }
}

// Size Chart toggle
function sizeChartToggle() {
  const element = document.getElementById("product-size-chart-popup");
  // console.log(element, element.style.display);
  element.style.display = element.style.display == "block" ? "none" : "block";
}

function loadSmartrrProduct(uniqueId, productJSON) {
  window.smartrrProductList[uniqueId] = {
    uniqueId,
    ui: undefined,
    logic: undefined,
    appId: "4836205",
    hiddenGroup: "[hidden]",
    formTag: "data-smartrr-form-id",
    product: productJSON,
    /* Called at DOMContentLoaded when initSmartrr creates the UI and Logic Modules */
    /* Used to inform the Modules of changes in Variants and Plans */
    uiImplementDetectChange: function (ui) {
      var groupList = ui.apiQuerySelectorAllDataTag(
        "data-smartrr-selling-plan-group-input",
        ui.$form
      );
      var selectedGroup = "";
      groupList &&
        groupList.forEach(function (group) {
          if (group.checked) {
            selectedGroup = ui.apiGetAttribute(
              group,
              "data-smartrr-selling-plan-group-input"
            );
          }
        });

      /* Inform the Logic handler about the variant selected when the page loads. */
      var variantId = ui.apiGetAttribute(
        ui.apiQuerySelectorDataTag("data-smartrr-page-load-variant", ui.$form),
        "data-smartrr-page-load-variant"
      );

      ui.logic.apiSetupVariantAndGroup(variantId, selectedGroup);

      /* Handle the variant selector on the page here. */
      /* Get the variant selector/buttons. On change/click, get the variant id and call ui.logic.apiChangeVariant(variantId); */
      /* Example code shows how to handle a swatch */
      /*
    var variantButtons = ui.$form.querySelectorAll('.swatch.clearfix input');
    variantButtons.forEach(function(variantInput) {
      variantInput.addEventListener('click', function() {
        var variantName = ui.apiGetValue(variantInput);
        var variant = ui.logic.apiGetVariantByName(variantName);
        ui.logic.apiChangeVariant(variant.id);
      });
    });
    */

      // Variant Detection for Dawn Themes
      var selects = ui.$form ? ui.$form.querySelector("variant-selects") : null;
      if (selects) {
        selects.addEventListener("change", (e) => {
          ui.logic.apiChangeVariant(selects.currentVariant.id);
        });
      }

      var radios = ui.$form ? ui.$form.querySelector("variant-radios") : null;
      if (radios) {
        radios.addEventListener("change", (e) => {
          ui.logic.apiChangeVariant(radios.currentVariant.id);
        });
      }

      /* Handle the plan selectors for each group. In this case, it is a <select> */
      var planSelectors = ui.apiQuerySelectorAllDataTag(
        "data-smartrr-selling-plans-select",
        ui.$form
      );
      planSelectors.forEach(function (planSelector) {
        planSelector.addEventListener("change", function () {
          ui.logic.apiChangePlan(ui.apiGetValue(planSelector));
        });
      });

      /* Signal possible change in pricing displays when quantity is changed */
      /*
    var qty = ui.$form.querySelector('input[name="quantity"]');
    qty.addEventListener("change", function() {
      ui.logic.apiChangePlan(ui.logic.apiGetCurrentCopy().planId);
    });
    */
    },

    /* Called when Plan (the subscription frequency) is changed. */
    /* Called when One time purchase is selected. */
    uiOnPlanChange: function (ui, currentInfo) {
      if (currentInfo.groupId && currentInfo.planId) {
        /* Ensures the <select> option reflects the change in planId. */
        ui.apiSetValue(
          ui.apiQuerySelectorDataTag(
            "data-smartrr-selling-plans-select",
            ui.$form,
            currentInfo.groupId
          ),
          currentInfo.planId
        );
      }
    },
    /* Called when the group (One time purchase / Subscribe & Save) is changed. */
    uiOnGroupChange: function (ui, currentInfo) {
      /* Use this to implement active class on Groups */
      /*
    var groupDivs = ui.apiQuerySelectorAllDataTag('data-smartrr-selling-plan-group-id', ui.$form);
    groupDivs.forEach(function(group) {
      if (currentInfo.groupId === ui.apiGetAttribute(group, 'data-smartrr-selling-plan-group-id')) {
        group.classList.add('smartrr-group-active');
      } else {
        group.classList.remove('smartrr-group-active');
      }
    });
    */
    },

    /* Called when the variant is changed */
    uiOnVariantChange: function (ui, currentInfo) {},

    /* Called when the quantity is retrieved for used in pricing display calculation. */
    uiGetQuantity: function (ui) {
      /* Handle the quantity input on the page here. */
      /* return 1 if you don't want quantity to be considered in pricing display elements */
      /* return ui.apiGetValue(ui.$form.querySelector('input[name="quantity"]')); */
      return 1;
    },

    uiModifyPrice: function (ui, $div, money) {
      /*
    Change price here based on requirements. For example, setting up per case/pound/bag price.
    money.regular: amount that shows up when strike display is chosen. This is the original un-discounted price.
    money.subscribe: the final discounted price or one-time price that shows up in the checkout.
    */
      return money;
    },
  };

  function waitForVue() {
    if (document.body.classList.contains("loaded")) {
      window.initSmartrr && window.initSmartrr(uniqueId);
    } else {
      setTimeout(waitForVue, 1200);
    }
  }
  waitForVue();
}

// Notify Me Popup Logic for Product Page and Listing (BEM classes) using event delegation
(function() {
  document.body.addEventListener('click', function(e) {
    // Handle Notify Me button click
    if (e.target.classList.contains('notify-me__button')) {
      e.preventDefault();
      var btn = e.target;
      var variantId = btn.dataset.variantId;
      var popup;
      if (variantId) {
        popup = document.querySelector('.notify-me[data-variant-id="' + variantId + '"]');
      } else {
        // Product page
        popup = document.querySelector('.notify-me');
      }
      // console.log('[NotifyMe] Button clicked via delegation', {btn, variantId, popup});
      if (popup) {
        popup.classList.add('active');
        // console.log('[NotifyMe] Popup should now be visible', popup.classList);
      } else {
        // console.log('[NotifyMe] Could not find popup for variant', variantId);
      }
      return;
    }

    // Handle overlay click (close popup)
    if (e.target.classList.contains('notify-me__overlay')) {
      var popup = e.target.closest('.notify-me');
      if (popup) {
        popup.classList.remove('active');
        // console.log('[NotifyMe] Popup closed by overlay click');
      }
      return;
    }

    // Handle close button click
    if (e.target.classList.contains('notify-me__close')) {
      var popup = e.target.closest('.notify-me');
      var form = popup.querySelector('.notify-me__form');
      var success = popup.querySelector('.notify-me__success');
      popup.classList.remove('active');
      // Reset form and success state
      form.style.display = '';
      success.style.display = 'none';
      // console.log('[NotifyMe] Popup closed by close button');
      return;
    }
  });
})();

// Back In Stock Submit Handler (works for both product and listing)
function backInStockSubmit(e, variantId) {
  e.preventDefault();
  var form = e.target;
  var popup = form.closest('.notify-me');
  // If variantId is not passed, get from hidden input (product page)
  if (!variantId) {
    variantId = form.querySelector('.notify-me__variant-id').value;
  }
  var emailInput = form.querySelector('.notify-me__email');
  var subscribeInput = form.querySelector('.notify-me__subscribe');
  var success = popup.querySelector('.notify-me__success');

  var email = emailInput.value.trim().toLowerCase();
  var subscribe = subscribeInput.checked;

  // console.log('[NotifyMe] Form submit', {variantId, email, subscribe});

  if (!variantId || !email) {
    alert("Email required");
    // console.log('[NotifyMe] Email or variantId missing');
    return;
  }

  if (subscribe) {
    // Add to newsletter using new Klaviyo API
    var listId = "UbqLgR";
    var now = new Date().toISOString();
    var newsletterPayload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED",
                      consented_at: now
                    }
                  }
                }
              }
            }
          },
          custom_source: "Notify Me form"
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId
            }
          }
        }
      }
    };
    fetch("https://a.klaviyo.com/client/subscriptions?company_id=SXpFc8", {
      method: "POST",
      headers: {
        "accept": "application/vnd.api+json",
        "content-type": "application/vnd.api+json",
        "revision": "2025-07-15"
      },
      body: JSON.stringify(newsletterPayload)
    })
    .then(function(res) {
      // console.log("[NotifyMe] Subscribed to newsletter (new API)", res);
    })
    .catch(function(err) {
      // console.log("[NotifyMe] Error subscribing to newsletter (new API)", err);
    });
  }

  var payload = {
    "data": {
      "type": "back-in-stock-subscription",
      "attributes": {
        "profile": {
          "data": {
            "type": "profile",
            "attributes": {
              "email": email
            }
          }
        },
        "channels": ["EMAIL"]
      },
      "relationships": {
        "variant": {
          "data": {
            "type": "catalog-variant",
            "id": `$shopify:::$default:::${variantId}`
          }
        }
      }
    }
  };

  var requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "revision": "2024-06-15"
    },
    body: JSON.stringify(payload)
  };

  fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=SXpFc8", requestOptions)
    .then(function(result) {
      form.style.display = 'none';
      success.style.display = 'block';
      // console.log('[NotifyMe] Success state shown');
    })
    .catch(function(error) {
      alert("Error submitting. Please try again.");
      // console.log('[NotifyMe] Error submitting', error);
    });
}

function initBarba() {
  if (typeof barba !== "undefined") {
    barba.init({
      prevent: ({ el }) => {
        return el.classList && !el.classList.contains("barba");
      },
      views: [
        {
          namespace: "product",
          beforeEnter() {
            // window.wetheme.onLoadAll()
            // Shopify.PaymentButton.init()
          },
        },
      ],
      transitions: [
        {
          name: "default-transition",
          leave(data) {
            // Remove active class from product selector grid
            const elements = document.querySelectorAll(".active.barba");
            elements.forEach((element) => {
              element.classList.remove("active");
            });
            const element = document.getElementById("nutrition");
            // Get the computed style of the element
            const computedStyle = window.getComputedStyle(element);
            // Get the background color property
            const backgroundColor = computedStyle.backgroundColor;
            const height = element.offsetHeight;
            document.body.setAttribute(
              "data-product-bg-color",
              backgroundColor
            );
            document.body.setAttribute("data-product-bg-height", height);
            gsap.to(".product-details-product-title", { opacity: 0 });
            gsap.to(".product-description", { opacity: 0 });
            gsap.to(".nutrition-grid", { opacity: 0 });
            gsap.to(".paymentButtonsWrapper", { opacity: 0 });
            gsap.to(".pdp-rating", { opacity: 0 });
            return gsap.to(".product-images-container", { opacity: 0 });
          },
          enter(data) {
            // return gsap.fromTo(data.next.container, { opacity: 0 }, { opacity: 1, duration: 2 });
            // return gsap.fromTo(".product-details-product-title", { opacity: 0 }, { opacity: 1, duration: 2 });
          },
          after(data) {
            const prevBgColor = document.body.getAttribute(
              "data-product-bg-color"
            );
            const prevHeight = document.body.getAttribute(
              "data-product-bg-height"
            );
            const element = document.getElementById("nutrition");
            // Get the computed style of the element
            const computedStyle = window.getComputedStyle(element);
            // Get the background color property
            const backgroundColor = computedStyle.backgroundColor;
            const height = element.offsetHeight;

            window.wetheme.onLoadAll();
            Shopify.PaymentButton.init();
            StampedFn.reloadUGC();

            gsap.fromTo(
              ".product-details-product-title",
              { opacity: 0 },
              { opacity: 1, duration: 2 }
            );
            gsap.fromTo(
              ".product-description",
              { opacity: 0 },
              { opacity: 1, duration: 2 }
            );
            gsap.fromTo(
              ".nutrition-container",
              { backgroundColor: prevBgColor },
              { backgroundColor: backgroundColor, duration: 2 }
            );
            gsap.fromTo(
              ".nutrition-container",
              { height: prevHeight },
              { height: height, duration: 0.5 }
            );
            gsap.fromTo(
              ".nutrition-grid",
              { opacity: 0 },
              { opacity: 1, duration: 2, delay: 1 }
            );
            gsap.fromTo(
              ".paymentButtonsWrapper",
              { opacity: 0 },
              { opacity: 1, duration: 2, delay: 1 }
            );
            gsap.fromTo(
              ".pdp-rating",
              { opacity: 0 },
              { opacity: 1, duration: 2 }
            );
            gsap.fromTo(
              ".product-images-container",
              { opacity: 0 },
              { opacity: 1, duration: 2 }
            );

            // setup Smartrr
            const e = document.getElementById("smartrr_unique_id");
            if (e) {
              const uniqueID = e.getAttribute("data-id");
              const escapedJSON = e.getAttribute("data-json");
              // Parse the JSON string into a JavaScript object
              var productJSON = JSON.parse(escapedJSON);

              loadSmartrrProduct(uniqueID, productJSON);
              const smartrrOtp = document.querySelector(".smartrr-otp input");
              if (smartrrOtp) {
                smartrrOtp.click();
              }
            }
          },
        },
      ],
    });
  } else {
    // Retry after a short delay if barba isn't loaded yet
    setTimeout(initBarba, 100);
  }
}

// Start the initialization process when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBarba);
} else {
  initBarba();
}
